import * as React from "react";

import { useScreenSize } from "./use-screen-size";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
    const screenSize = useScreenSize();

    return screenSize.lessThan("lg");
}
